module.exports = __webpack_public_path__ + "img/login_pwd_logo.b4070dc1.png";